var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" 当前路径不存在，请检查网址是否正确 "),_c('br'),_c('router-link',{attrs:{"to":"/"}},[_vm._v("返回首页")]),_c('br'),_c('a',{attrs:{"href":"/#"}},[_vm._v("返回首页")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }